<template>
  <layout-basic>
    <page-hero
      title="Employee Onboarding"
      lead="Give every new employee the same great start with structured onboarding."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="features" />
      </v-container>
    </section>

    <point-grid
      title="What onboarding looks like with IMPROVE"
      :points="points"
      :columns="2"
      tint
    />

    <quote-row :quotes="pageQuotes" />

    <standard-cta
      title="Ready to improve onboarding?"
      lead="See how IMPROVE helps growing businesses get new starters productive faster."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import QuoteRow from '@/components/marketing/QuoteRow.vue';
import {
  MANUFACTURING_INDUCTION,
  ADVOCACY_FOCUS_ONBOARDING,
} from '@/data/testimonials';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'SolutionOnboarding',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    QuoteRow,
    StandardCta,
    DemoVideo,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Employee Onboarding | IMPROVE',
      description:
        'Give every new employee the same great start with structured onboarding on IMPROVE.',
      path: '/solutions/onboarding',
    });
  },
  data() {
    return {
      pageQuotes: [MANUFACTURING_INDUCTION, ADVOCACY_FOCUS_ONBOARDING],
      points: [
        'Structured pathways from day one',
        'Consistent induction across every team',
        'Assign mandatory training automatically',
        'Track completion from one dashboard',
        'Upload policies, procedures and videos',
        'Reduce time-to-productivity',
      ],
    };
  },
};
</script>
